function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M169 80.8613C169.032 93.1067 166.171 105.186 160.65 116.117C154.104 129.215 144.04 140.231 131.587 147.933C119.133 155.634 104.781 159.717 90.1388 159.722C77.8933 159.754 65.8135 156.893 54.8832 151.372L2 169L19.6278 116.117C14.1068 105.186 11.2458 93.1067 11.2778 80.8613C11.2834 66.2187 15.3657 51.8669 23.0672 39.4133C30.7687 26.9598 41.7854 16.8963 54.8832 10.3503C65.8135 4.82934 77.8933 1.96834 90.1388 2.00026H94.7776C114.116 3.06713 132.381 11.2294 146.076 24.9243C159.771 38.6192 167.933 56.8843 169 76.2224V80.8613Z",
  stroke: "white",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 64,
  y: 36,
  width: 52,
  height: 93,
  fill: "#EE3F58"
}), /*#__PURE__*/React.createElement("path", {
  d: "M119 82.5382C119 95.9166 119 109.333 119 122.712C119 127.451 116.03 131.083 111.46 131.847C110.888 131.962 110.317 131.962 109.746 131.962C96.5693 131.962 83.3546 131.962 70.1779 131.962C64.9225 131.962 61 128.178 61 122.864C61 95.9548 61 69.0452 61 42.0973C61.0381 36.8224 64.9225 33 70.1779 33C83.3546 33 96.5693 33 109.746 33C115.116 33 118.962 36.8606 119 42.2502C119 55.705 119 69.1216 119 82.5382ZM77.9468 128.522C79.3559 124.776 81.6028 123.17 85.4491 123.17C88.61 123.17 91.7708 123.17 94.9317 123.17C98.2068 123.208 100.492 124.776 101.749 127.795C101.977 128.369 102.244 128.56 102.815 128.522C105.062 128.483 107.309 128.522 109.555 128.522C113.288 128.522 115.534 126.266 115.534 122.52C115.534 95.8019 115.534 69.0834 115.534 42.3649C115.534 38.6954 113.288 36.4019 109.632 36.4019C96.5312 36.4402 83.4307 36.4402 70.2922 36.4402C69.7971 36.4402 69.302 36.4402 68.807 36.5548C66.0269 37.1664 64.4274 39.3452 64.4274 42.5942C64.4274 69.1981 64.4274 95.8019 64.4274 122.406C64.4274 122.903 64.4655 123.4 64.5036 123.897C64.8464 126.381 66.8647 128.407 69.302 128.522C72.1963 128.636 75.0525 128.522 77.9468 128.522ZM98.283 128.522C97.5975 127.375 96.7597 126.725 95.6172 126.687C91.847 126.649 88.0768 126.61 84.3066 126.687C83.2022 126.725 82.2882 127.337 81.7551 128.483C87.3152 128.522 92.7229 128.522 98.283 128.522Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M89.9809 42.4796C88.3433 42.4796 86.7058 42.4796 85.0682 42.4796C83.9257 42.4796 83.1641 41.7915 83.1641 40.7977C83.1641 39.8039 83.8876 39.0776 85.0301 39.0394C88.3433 39.0012 91.6565 39.0012 94.9697 39.0394C96.1503 39.0394 96.8738 39.7657 96.8738 40.7595C96.8738 41.7915 96.1503 42.4796 94.8935 42.4796C93.2179 42.5178 91.6184 42.4796 89.9809 42.4796Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.0636 40.8359C70.0255 39.3451 71.2442 38.122 72.6913 38.0838C74.1385 38.0455 75.3571 39.2687 75.3571 40.7594C75.3571 42.2119 74.2527 43.3587 72.8056 43.4351C71.3203 43.5116 70.1017 42.3266 70.0636 40.8359Z",
  fill: "white"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 58,
  height: 99,
  fill: "white",
  transform: "translate(61 33)"
})));

var SvgPhoneInMessage = function SvgPhoneInMessage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 171,
    viewBox: "0 0 171 171",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhoneInMessage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone-in-message.5669d150.svg";
export { ForwardRef as ReactComponent };